import React, { useState, useEffect } from 'react';

function SwapBlock() {
  // Состояния для данных и UI
  const [tokens, setTokens] = useState(null);
  const [balance, setBalance] = useState(null); // Баланс пользователя
  const [searchQuery1, setSearchQuery1] = useState('');
  const [searchQuery2, setSearchQuery2] = useState('');
  const [token1, setToken1] = useState('USDT');
  const [token2, setToken2] = useState('BTC');
  const [amount1, setAmount1] = useState('');
  const [amount2, setAmount2] = useState('');
  const [activeField, setActiveField] = useState('field1');
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  // Модальные окна
  const [showModal, setShowModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  // Состояние анимации обмена монет
  const [swapAnimating, setSwapAnimating] = useState(false);
  // Таймер обновления курсов
  const [timer, setTimer] = useState(9);

  const tg = window.Telegram.WebApp;
  const user_id = tg.initDataUnsafe.user.id;

  // Получение баланса при монтировании компонента
  useEffect(() => {
    fetch(`/balance/${user_id}`)
      .then((res) => res.json())
      .then((data) => setBalance(data))
      .catch((err) => console.error('Ошибка получения баланса:', err));
  }, [user_id]);

  // Функция для получения курсов
  const fetchData = () => {
    fetch('/rate')
      .then((res) => res.json())
      .then((data) => setTokens(data))
      .catch((err) => console.error('Ошибка получения курсов:', err.message));
  };

  // Получаем курсы сразу при монтировании
  useEffect(() => {
    fetchData();
  }, []);

  // Таймер, который отсчитывает секунды и обновляет курсы каждые 4 секунд
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          fetchData();
          return 9;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => clearInterval(countdownInterval);
  }, []);

  if (!tokens) {
    return <div>Loading...</div>;
  }
  
  const t1 = tokens[token1];
  const t2 = tokens[token2];

  // Обработчик для кнопки Swap с анимацией поворота
  const handleSwap = () => {
    setSwapAnimating(true);
    setTimeout(() => {
      setToken1(token2);
      setToken2(token1);
      const temp = amount1;
      setAmount1(amount2);
      setAmount2(temp);
      setActiveField('field1');
      setSwapAnimating(false);
    }, 300);
  };

  // Обработчики ввода – теперь без задержек и спиннеров
  const onChangeAmount1 = (e) => {
    setActiveField('field1');
    setAmount1(e.target.value);
  };

  const onChangeAmount2 = (e) => {
    setActiveField('field2');
    setAmount2(e.target.value);
  };

  const sellPrice1 = t1.sell.price;
  const buyPrice2 = t2.buy.price;
  let computedAmount1 = amount1;
  let computedAmount2 = amount2;

  if (activeField === 'field1') {
    const val1 = parseFloat(amount1) || 0;
    computedAmount2 = buyPrice2 ? (val1 * sellPrice1 / buyPrice2).toFixed(8) : '';
  } else if (activeField === 'field2') {
    const val2 = parseFloat(amount2) || 0;
    computedAmount1 = sellPrice1 ? (val2 * buyPrice2 / sellPrice1).toFixed(8) : '';
  }

  const displayAmount1 = activeField === 'field2' ? computedAmount1 : amount1;
  let displayAmount2 = activeField === 'field1' ? computedAmount2 : amount2;
  console.log(3434, displayAmount2)

  if (parseFloat(displayAmount2) > 1) {
    displayAmount2 = parseFloat(displayAmount2).toFixed(5);
  }

  // Фильтрация токенов для выпадающих списков
  const filteredTokens1 = Object.entries(tokens).filter(([key, info]) => {
    if (!searchQuery1) return true;
    const query = searchQuery1.toLowerCase();
    return info.title.toLowerCase().includes(query) || key.toLowerCase().includes(query);
  });

  const filteredTokens2 = Object.entries(tokens).filter(([key, info]) => {
    if (!searchQuery2) return true;
    const query = searchQuery2.toLowerCase();
    return info.title.toLowerCase().includes(query) || key.toLowerCase().includes(query);
  });

  const sortedTokens1 = filteredTokens1.sort(([keyA], [keyB]) => {
    const hasBalanceA = balance && balance.balances && keyA in balance.balances;
    const hasBalanceB = balance && balance.balances && keyB in balance.balances;
    if (hasBalanceA && !hasBalanceB) return -1;
    if (!hasBalanceA && hasBalanceB) return 1;
    return 0;
  });

  // Проверка: если сумма (в долларах) меньше $1 – отключаем кнопку Confirm
  const usdValue = (parseFloat(displayAmount1) || 0) * t1.sell.price;
  const isConfirmDisabled = usdValue <= 6 || !t1 || !t2;

  // Расчет комиссии и итоговой суммы, которую получит пользователь
  const token2Amount = parseFloat(activeField === 'field1' ? computedAmount2 : displayAmount2) || 0;  
  const token2Usd = token2Amount * t2.sell.price;
  let feeUsd = 0;
  if (token2Usd <= 100) {
    feeUsd = 5;
  } else if (token2Usd <= 1000) {
    feeUsd = 7;
  } else if (token2Usd < 10000) {
    feeUsd = 10;
  } else {
    feeUsd = 15;
  }
  const feeToken2 = feeUsd / t2.sell.price;
  const finalReceived = (token2Amount - feeToken2).toFixed(9);
  

  // Обработчик для кнопки Confirm, отправляет POST запрос на /add
  const handleConfirm = async () => {
    setErrorMessage('');
    const payload = {
      user_id: user_id,
      give: token1,
      recipient: token2,
      give_value: parseFloat(displayAmount1) || 0,
      recipient_value: parseFloat(finalReceived) || 0,
      from_who: 'swap' 
    };

    try {
      const response = await fetch('/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.error || 'Transaction failed');
      } else {
        const data = await response.json();
        setShowModal(false);
        setResultMessage(data.message || 'Transaction added successfully');
        setShowResultModal(true);

        fetch(`/balance/${user_id}`)
          .then((res) => res.json())
          .then((balanceData) => setBalance(balanceData))
          .catch((err) => console.error('Ошибка получения баланса:', err));
      }
    } catch (error) {
      setErrorMessage('Ошибка при добавлении транзакции: ' + error.message);
    }
  };

  

  return (
    <div className="animated-container" style={{ justifyContent: 'center' }}>
      {/* Стили для анимаций и плавного перехода */}
      <style>
        {`
          @keyframes slideIn {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
          .animated-container {
            animation: slideIn 0.5s ease-in-out;
          }
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
          .animated-button:hover {
            animation: bounce 0.5s;
          }
          .animated-button:active {
            transform: scale(0.95);
            transition: transform 0.1s;
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .fade-in {
            animation: fadeIn 0.3s ease-in-out;
          }
          .rotate-coins {
            animation: rotateCoins 0.3s ease-in-out;
          }
          @keyframes rotateCoins {
            0% { transform: rotateY(0deg); }
            50% { transform: rotateY(90deg); }
            100% { transform: rotateY(0deg); }
          }
          .dropdown {
            opacity: 0;
            transform: translateY(-10px);
            transition: opacity 0.3s ease, transform 0.3s ease;
          }
          .dropdown.show {
            opacity: 1;
            transform: translateY(0);
          }
          .number-transition {
            transition: all 0.3s ease;
          }
        `}
      </style>

      <div
        style={{
          backgroundColor: '#2A2A33',
          padding: 15,
          marginTop: 40,
          marginBottom: 20,
          border: '1px solid #3E3E4B',
          borderRadius: 20,
        }}
      >
        {/* Заголовок с таймером обновления */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ color: 'white', marginLeft: 5 }}>Swap</h3>
          <span style={{ color: '#7E7E95', fontSize: 14, marginRight: 5 }}>
            Обновление через: {timer}s
          </span>
        </div>

        {/* Первый блок – сколько платим (token1) */}
        <div style={{ position: 'relative', marginTop: 20 }}>
          <div
            style={{
              backgroundColor: '#1F1F25',
              borderRadius: 20,
              border: '1px solid #3E3E4B',
              padding: 15,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div
                onClick={() => {
                  setShowDropdown1(!showDropdown1);
                  setSearchQuery1('');
                }}
                className={`animated-button ${swapAnimating ? 'rotate-coins' : ''}`}
                style={{
                  backgroundColor: '#60BDFF33',
                  display: 'flex',
                  width: 160,
                  height: 45,
                  borderRadius: 20,
                  cursor: 'pointer',
                }}
              >
                <p style={{ color: '#60BDFF', margin: 10, marginLeft: 15 }}>
                  <img src={t1.icon} style={{ height: 18 }} alt={t1.title} /> {token1}
                </p>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: 20 }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7614 1.92872L6.57614 7.25487C6.25794 7.58171 5.74206 7.58171 5.42386 7.25487L0.238644 1.92872C-0.079547 1.60188 -0.079547 1.07197 0.238644 0.745129C0.556834 0.41829 1.07272 0.41829 1.39091 0.745129L6 3.5L10.6091 0.745129C10.9273 0.41829 11.4432 0.41829 11.7614 0.745129C12.0795 1.07197 12.0795 1.60188 11.7614 1.92872Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p style={{ color: '#5D5D6F', marginTop: 10, marginRight: 10 }}>You pay</p>
            </div>
            <hr style={{ color: '#FFFFFF' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ position: 'relative', width: '50%' }}>
                <input
                  style={{
                    width: '100%',
                    height: 35,
                    backgroundColor: 'transparent',
                    border: 'none',
                    outline: 'none',
                    color: 'white',
                    fontSize: 25,
                  }}
                  placeholder="0"
                  value={displayAmount1}
                  onChange={onChangeAmount1}
                />
              </div>
              <p className="number-transition" style={{ color: 'white' }}>
                {t1 ? `$${(t1.price * (parseFloat(displayAmount1) || 0)).toFixed(2)}` : ''}
              </p>
            </div>
          </div>
          {showDropdown1 && (
            <div
              className={`dropdown ${showDropdown1 ? 'show' : ''}`}
              style={{
                position: 'absolute',
                top: 60,
                left: 15,
                backgroundColor: '#1F1F25',
                border: '1px solid #3E3E4B',
                borderRadius: 10,
                zIndex: 10,
                width: 300,
              }}
            >
              <div>
                <input
                  type="text"
                  placeholder="Поиск токена"
                  value={searchQuery1}
                  onChange={(e) => setSearchQuery1(e.target.value)}
                  style={{
                    width: '100%',
                    backgroundColor: '#2D2D33',
                    border: 'none',
                    outline: 'none',
                    color: 'white',
                    borderRadius: 5,
                    padding: '5px 10px',
                    height: 60,
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}></div>
              <div style={{ maxHeight: 290, overflowY: 'auto' }}>
                {sortedTokens1.map(([key, info]) => (
                  <div
                    key={key}
                    onClick={() => {
                      setToken1(key);
                      setShowDropdown1(false);
                      setSearchQuery1('');
                    }}
                    style={{
                      padding: '9px 12px',
                      cursor: 'pointer',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img src={info.icon} style={{ height: 32, marginRight: 18 }} alt={info.title} /> {info.title}
                    </div>
                    {balance && balance.balances && balance.balances[key] !== undefined && (
                      <span style={{ fontSize: 12, color: '#60BDFF' }}>{balance.balances[key]}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Кнопка Swap */}
        <div
          onClick={handleSwap}
          className="animated-button"
          style={{
            display: 'flex',
            justifyContent: 'center',
            cursor: 'pointer',
            marginTop: 5,
          }}
        >
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#0F0F12" />
            <circle cx="18" cy="18" r="17.5" stroke="#3E3E4B" strokeOpacity="0.3" />
            <path d="M14.2667 20H10L16.4 26V10H14.2667V20ZM19.6 13V26H21.7333V16H26L19.6 10V13Z" fill="#60BDFF" />
          </svg>
        </div>

        {/* Второй блок – сколько получаем (token2) */}
        <div style={{ position: 'relative', marginTop: 5 }}>
          <div
            style={{
              backgroundColor: '#1F1F25',
              borderRadius: 20,
              border: '1px solid #3E3E4B',
              padding: 15,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div
                onClick={() => {
                  setShowDropdown2(!showDropdown2);
                  setSearchQuery2('');
                }}
                className={`animated-button ${swapAnimating ? 'rotate-coins' : ''}`}
                style={{
                  backgroundColor: '#60BDFF33',
                  display: 'flex',
                  width: 160,
                  height: 45,
                  borderRadius: 20,
                  cursor: 'pointer',
                }}
              >
                <p style={{ color: '#60BDFF', margin: 10, marginLeft: 15 }}>
                  <img src={t2.icon} style={{ height: 20 }} alt={t2.title} /> {token2}
                </p>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: 20 }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7614 1.92872L6.57614 7.25487C6.25794 7.58171 5.74206 7.58171 5.42386 7.25487L0.238644 1.92872C-0.079547 1.60188 -0.079547 1.07197 0.238644 0.745129C0.556834 0.41829 1.07272 0.41829 1.39091 0.745129L6 3.5L10.6091 0.745129C10.9273 0.41829 11.4432 0.41829 11.7614 0.745129C12.0795 1.07197 12.0795 1.60188 11.7614 1.92872Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p style={{ color: '#5D5D6F', marginTop: 10, marginRight: 10 }}>You get</p>
            </div>
            <hr style={{ color: '#FFFFFF' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ position: 'relative', width: '60%' }}>
                <input
                  style={{
                    width: '100%',
                    height: 35,
                    backgroundColor: 'transparent',
                    border: 'none',
                    outline: 'none',
                    color: 'white',
                    fontSize: 25,
                  }}
                  placeholder="0"
                  value={displayAmount2}
                  onChange={onChangeAmount2}
                />
              </div>
              <p
                className="number-transition"
                style={{
                  color: 'white',
                  fontSize: 13,
                  marginTop: 5,
                }}
              >
                {displayAmount2
                  ? `$${(t2.price * (parseFloat(displayAmount2) || 0)).toFixed(2)}`
                  : ''
                }
              </p>
            </div>
          </div>
          {showDropdown2 && (
            <div
              className={`dropdown ${showDropdown2 ? 'show' : ''}`}
              style={{
                position: 'absolute',
                top: 60,
                left: 15,
                backgroundColor: '#1F1F25',
                border: '1px solid #3E3E4B',
                borderRadius: 10,
                zIndex: 10,
                width: 300,
              }}
            >
              <div>
                <input
                  type="text"
                  placeholder="Поиск токена"
                  value={searchQuery2}
                  onChange={(e) => setSearchQuery2(e.target.value)}
                  style={{
                    width: '100%',
                    backgroundColor: '#2D2D33',
                    border: 'none',
                    outline: 'none',
                    color: 'white',
                    borderRadius: 5,
                    padding: '5px 10px',
                    height: 60,
                  }}
                />
              </div>
              <div style={{ marginTop: 10 }}></div>
              <div style={{ maxHeight: 290, overflowY: 'auto' }}>
                {filteredTokens2.map(([key, info]) => (
                  <div
                    key={key}
                    onClick={() => {
                      setToken2(key);
                      setShowDropdown2(false);
                      setSearchQuery2('');
                    }}
                    style={{
                      padding: '9px 12px',
                      cursor: 'pointer',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img src={info.icon} style={{ height: 32, marginRight: 18 }} alt={info.title} /> {info.title}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Блок с курсом и комиссией */}
        {isConfirmDisabled ? (
          <p style={{ color: '#FF6063', textAlign: 'center', marginTop: 10 }}>
            Ensure amount &gt; $1 and tokens selected.
          </p>
        ) : (
          <div
            style={{
              backgroundColor: '#0F0F12',
              borderRadius: 18,
              padding: 15,
              marginTop: 10,
            }}
          >
            <div style={{ display: 'flex' }}>
              <div style={{ justifyContent: 'space-between', width: '100%' }}>
                {t1 && t2 && (
                  <>
                    <span style={{ color: 'white' }}>
                      <b>1</b> {token1} = <b>{(t1.sell.price / t2.buy.price).toFixed(8)} </b> {token2}
                    </span>
                    <br />
                    <span style={{ color: '#7E7E95' }}>
                      Sell: <b>{parseFloat(t2.sell.price) < 1
                        ? parseFloat(t2.sell.price)
                        : parseFloat(t2.sell.price).toFixed(2)
                      }</b>  |  Buy: <b>{parseFloat(t2.buy.price) < 1
                        ? parseFloat(t2.buy.price)
                        : parseFloat(t2.buy.price).toFixed(2)
                      }</b>
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Кнопка Confirm */}
      <button
        className="btn animated-button"
        disabled={isConfirmDisabled}
        onClick={() => setShowModal(true)}
        style={{
          backgroundColor: isConfirmDisabled ? '#ccc' : '#60BDFF',
          width: '100%',
          marginTop: 5,
          marginBottom: 30,
          borderRadius: 30,
          fontWeight: 700,
          fontSize: 16,
          height: 60,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
          <i className="bi bi-check2" style={{ fontSize: 25, fontWeight: 700 }}></i>
          <p style={{ marginTop: 7 }}>Confirm</p>
        </div>
      </button>

      {/* Модальное окно для подтверждения транзакции */}
      {showModal && (
        <div
          className="fade-in"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: 'linear-gradient(180deg, #1F1F25 0%, #2F3F2F 180%)',
              padding: 20,
              border: '1px solid #3E3E4B',
              borderRadius: 10,
              maxWidth: 400,
              width: '93%',
            }}
          >
            <div>
              <div className="d-flex justify-content-center mb-4">
                <h3 style={{ color: 'white' }}>Транзакция отправлена</h3>
              </div>
              <div className="d-flex justify-content-center mb-4">
                <svg
                  width="92"
                  height="92"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3ECF8E"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="8" />
                  <polyline points="8 12 12 8 16 12" />
                </svg>
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-center mb-4">
                <p style={{ color: 'white', fontSize: 18 }}>
                  Получаете {finalReceived} {token2}
                  <br />
                  Отправляете {(parseFloat(displayAmount1))} {token1}
                  <br />
                  Fee {feeToken2.toFixed(8)} {token2} ({feeUsd.toFixed(2)}$)
                  <br />
                  {errorMessage && (
                    <p style={{ color: '#FF6063', fontSize: 16 }}>{errorMessage}</p>
                  )}
                </p>
              </div>
            </div>
            <button
              onClick={handleConfirm}
              className="animated-button"
              style={{
                padding: '10px 20px',
                borderRadius: 10,
                backgroundColor: '#60BDFF',
                border: 'none',
                color: 'white',
                fontSize: 16,
                width: '100%',
                cursor: 'pointer',
              }}
            >
              Swap
            </button>
            <button
              onClick={() => {
                setShowModal(false);
                setErrorMessage('');
              }}
              className="animated-button"
              style={{
                marginTop: 10,
                padding: '10px 20px',
                borderRadius: 10,
                backgroundColor: '#60BDFF',
                border: 'none',
                color: 'white',
                fontSize: 16,
                width: '100%',
                cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Центрированное модальное окно для успешного результата */}
      {showResultModal && (
        <div
          className="modal d-block fade-in"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 p-4"
              style={{
                borderRadius: '15px',
                background: 'linear-gradient(180deg, #141414 0%, #1C1C1C 100%)',
              }}
            >
              <h5 className="text-white text-center mb-2">
                Transaction completed
              </h5>
              <p className="text-center mb-4" style={{ color: '#3ECF8E', fontWeight: '500' }}>
                You approved {token2}
              </p>
              <div className="d-flex justify-content-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    backgroundColor: '#3ECF8E',
                  }}
                >
                  <svg
                    width="32"
                    height="32"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
              </div>
              <button
                className="btn w-100 d-flex align-items-center justify-content-center animated-button"
                style={{
                  backgroundColor: '#1E1E1E',
                  borderRadius: '999px',
                  color: '#fff',
                  border: '1px solid #3ECF8E',
                  padding: '12px 16px',
                }}
                onClick={() => setShowResultModal(false)}
              >
                <svg
                  style={{ marginRight: '8px' }}
                  width="16"
                  height="16"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="19" y1="12" x2="5" y2="12" />
                  <polyline points="12 19 5 12 12 5" />
                </svg>
                Back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SwapBlock;
